<script>
import axios from "axios";

export default {
	data() {
		return {
			currencies_defaults: [
				{ value: "EUR", name: "🇪🇺 EUR", cur: 1, symbol: "€" },
				{ value: "CZK", name: "🇨🇿 CZK", cur: 24.5319, symbol: "Kč" },
				{ value: "HUF", name: "🇭🇺 HUF", cur: 403.5169, symbol: "Ft" },
				{ value: "PLN", name: "🇵🇱 PLN", cur: 4.6715, symbol: "zł" },
				{ value: "RON", name: "🇷🇴 RON", cur: 4.8768, symbol: "lei" },
				{ value: "UAH", name: "🇺🇦 UAH", cur: 37.5315, symbol: "₴" },
				{ value: "USD", name: "🇺🇸 USD", cur: 1.0164, symbol: "$" },
				{ value: "CHF", name: "🇨🇭 CHF", cur: 1.0164, symbol: "CHF" },
			],
		};
	},
	beforeMount() {
		this.$store.commit("currencies", this.setCurrencies());
		this.$store.commit("currencies_list", this.setCurrenciesList());
	},
	mounted() {
		this.getCurrencies();
	},
	methods: {
		setCurrenciesList() {
			let currencies_list = [];
			this.currencies_defaults.forEach((element) => {
				currencies_list.push({ value: element.value, name: element.name, symbol: element.symbol });
			});
			return currencies_list;
		},
		setCurrencies() {
			let currencies = {};
			this.currencies_defaults.forEach((element) => {
				currencies[element.value] = element.cur;
			});
			return currencies;
		},
		getCurrencies() {
			axios({
				method: "get",
				url: "https://api.exchangerate-api.com/v4/latest/EUR",
			})
				.then((response) => {
					let rates = response.data.rates;
					rates = Object.fromEntries(Object.entries(rates).filter(([key]) => Object.keys(this.$store.state.currencies).includes(key)));
					this.$store.commit("currencies", rates);
					console.log("Валюты получены");
				})
				.catch((error) => {
					console.log(error);
				});
		},
	},
};
</script>
